import {
  clearAllTooltip,
  showSideTeamStatusBar,
  tabHighlight,
} from './helpers';

import { createWebappRoute, getCurrentRouteParams } from '../helpers';

export default [
  createWebappRoute({
    path: '/approve/:id',
    name: 'timesheet-module-location-id',
    component() {
      console.log('ROUTER, /approve/:id');

      const { id } = getCurrentRouteParams();

      tabHighlight('timesheet');
      showSideTeamStatusBar(false);

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('timesheet');
          $dtw.vwWorkplace.tsa(id);
        };
        return;
      }

      $dtw.vwWorkplace.tsa(id);
      clearAllTooltip();

      return {};
    },
  }),
  createWebappRoute({
    path: '/approve/:locationId/record/:timesheetId',
    name: 'timesheet-module-timesheet-id',
    component() {
      const { locationId, timesheetId } = getCurrentRouteParams();
      console.log(
        'ROUTER, timesheet-module-timesheet-id',
        locationId,
        timesheetId
      );

      tabHighlight('timesheet');
      showSideTeamStatusBar(false);

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('timesheet');
          $dtw.vwWorkplace.tsaById(locationId, timesheetId);
        };

        return;
      }

      $dtw.vwWorkplace.tsaById(locationId, timesheetId);
      clearAllTooltip();

      return {};
    },
  }),
  createWebappRoute({
    path: '/approve',
    name: 'timesheet-module',
    component() {
      console.log('ROUTER, timesheet approve/*');

      tabHighlight('timesheet');
      showSideTeamStatusBar(false);

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('timesheet');
          $dtw.vwWorkplace.tsa($dt.objLoginUser.EmployeeProfileObject.Company);
        };

        return;
      }

      if ($dtw.vwWorkplace.appTSA) {
        // is there a rostering app?
        $dtw.vwWorkplace.appTSA.launch();
        $dtw.vwWorkplace.showAppWrapper();
        $dt.resizeViewport();
      } else {
        $dtw.vwWorkplace.tsa();
      }

      return {};
    },
  }),
  createWebappRoute({
    path: '/export',
    name: 'timesheet-export',
    component() {
      console.log('ROUTER, timesheet export/*');

      tabHighlight('timesheet');
      showSideTeamStatusBar(false);

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('timesheet');
          $dtw.vwWorkplace.tse($dt.objLoginUser.EmployeeProfileObject.Company);
        };
        return;
      }
      if ($dtw.vwWorkplace.appTSE) {
        // is there a rostering app?
        $dtw.vwWorkplace.appTSE.launch();
        $dtw.vwWorkplace.showAppWrapper();
        $dt.resizeViewport(); // Resize the viewPort in desktop here @added by Caesar Li 9th, Oct, 2012
      } else {
        $dtw.vwWorkplace.tse();
      }
    },
  }),
  createWebappRoute({
    path: '/export/:timesheetId',
    name: 'timesheet-export-by-id',
    component() {
      console.log('ROUTER, timesheet export by id/*');

      const { timesheetId } = getCurrentRouteParams();

      tabHighlight('timesheet');
      showSideTeamStatusBar(false);

      if (!$dtw.vwWorkplace) {
        $dt.rtrWPGoto = function() {
          tabHighlight('timesheet');
          $dtw.vwWorkplace.tse($dt.objLoginUser.EmployeeProfileObject.Company);
        };
        return;
      }
      $dtw.vwWorkplace.tse(timesheetId);
      clearAllTooltip();
    },
  }),
];
